import MenuIcon from '../assets/icons/menu.svg?react';
import MenuCloseIcon from '../assets/icons/close.svg?react';
import MeAvatar from './common/me-avatar.tsx';
import { matchPath, useLocation } from 'react-router-dom';
import { RoutesEnum } from '../utils/enums.ts';

interface IHeader {
  onClickMenu: () => void;
  isMenuOpen: boolean;
}

const HIDE_BRAND_ROUTES = [
  RoutesEnum.TEST_ATTEMPT_ATTEMPT_ID,
  RoutesEnum.QUIZ_ATTEMPT_ATTEMPT_ID,
];

const Header = ({ onClickMenu, isMenuOpen }: IHeader) => {
  const { pathname } = useLocation();
  const hideBrand = HIDE_BRAND_ROUTES.some((route) => matchPath(route, pathname));

  return (
    <header
      className={
        'flex h-[4rem] items-center justify-between bg-light-gray px-3 lg:pl-[17rem]'
      }
    >
      <div className={'flex items-center gap-3'}>
        {isMenuOpen ? (
          <MenuCloseIcon
            className={'cursor-pointer select-none lg:hidden'}
            onClick={onClickMenu}
          />
        ) : (
          <MenuIcon
            className={'cursor-pointer select-none lg:hidden'}
            onClick={onClickMenu}
          />
        )}

        {!hideBrand && (
          <div className={'text-lg font-semibold leading-none text-[#222]'}>
            SAT
          </div>
        )}
      </div>

      <MeAvatar />
    </header>
  );
};
export default Header;
